module.exports = __webpack_public_path__ + "static/media/raid_forum_theme_3.15e509df.jpg";